import "vite/modulepreload-polyfill";
import "../scss/style.scss";
// Show page after styles load to prevent flash
document.body.classList.add("loaded");
import { Modal } from "bootstrap";
import $ from "jquery";

// Bootstrap 5 modal helper functions
const showModal = (id) => Modal.getOrCreateInstance(document.getElementById(id)).show();
const hideModal = (id) => Modal.getOrCreateInstance(document.getElementById(id)).hide();

import Parse from "parse";
import config from "./config";
import FormValidator from "./helpers/FormValidator";

// Set jQuery globally
window.$ = window.jQuery = $;

// Async initialization function
async function initializeLogin() {
  // Load Popper asynchronously
  const { default: Popper } = await import("@popperjs/core");
  window.Popper = Popper;

  // Initialize Parse
  window.Parse = Parse;
  Parse.$ = $;

  Parse.initialize(config.parse.appId, config.parse.jsKey);
  Parse.serverURL = config.parse.serverUrl;
  Parse.User.logOut();
  Parse.LiveQuery.close();

  // Render Turnstile widgets — wait for script if not yet loaded
  await waitForTurnstile();
  renderTurnstileWidgets(config.turnstile.siteKey);

  // Set up form handling
  setupLoginForms(config.parse.appId);

  // Hide loading bar
  const loader = document.getElementById("app-loading");
  if (loader) {
    loader.classList.add("loaded");
    setTimeout(() => loader.remove(), 300);
  }
}

function waitForTurnstile() {
  if (typeof turnstile !== "undefined") return Promise.resolve();
  return new Promise(function (resolve) {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (typeof turnstile !== "undefined" || attempts > 50) {
        clearInterval(interval);
        resolve();
      }
    }, 100);
  });
}

// Turnstile widget IDs for resetting after submission
var turnstileWidgets = {};

function renderTurnstileWidgets(siteKey) {
  if (!siteKey || typeof turnstile === "undefined") return;

  var registerEl = document.getElementById("register-turnstile");
  if (registerEl) {
    turnstileWidgets.register = turnstile.render("#register-turnstile", {
      sitekey: siteKey,
      theme: "auto",
    });
  }

  var resetEl = document.getElementById("reset-turnstile");
  if (resetEl) {
    turnstileWidgets.reset = turnstile.render("#reset-turnstile", {
      sitekey: siteKey,
      theme: "auto",
    });
  }

  // Resend verification widget renders when modal opens
  var resendModal = document.getElementById("emailNotVerifiedModal");
  if (resendModal) {
    resendModal.addEventListener("shown.bs.modal", function () {
      if (turnstileWidgets.resend == null) {
        turnstileWidgets.resend = turnstile.render("#resend-turnstile", {
          sitekey: siteKey,
          theme: "auto",
        });
      } else {
        turnstile.reset(turnstileWidgets.resend);
      }
    });
  }
}

function getTurnstileToken(widgetKey) {
  if (turnstileWidgets[widgetKey] == null || typeof turnstile === "undefined")
    return null;
  return turnstile.getResponse(turnstileWidgets[widgetKey]);
}

function resetTurnstile(widgetKey) {
  if (turnstileWidgets[widgetKey] != null && typeof turnstile !== "undefined") {
    turnstile.reset(turnstileWidgets[widgetKey]);
  }
}

function setupLoginForms(parseApplicationID) {
  const urlParams = new URLSearchParams(window.location.search);
  let redirect = urlParams.has("redirect") ? urlParams.get("redirect") : "";
  // Only allow hash fragment redirects to prevent open redirect attacks
  if (redirect && !redirect.match(/^#[\w\-\/]*$/)) {
    redirect = "";
  }

  if (urlParams.has("user")) {
    $("#inputUsername").val(urlParams.get("user"));
  }

  /* set up validators */
  // form validator defaults using our new FormValidator
  const formValidators = [];
  $("form").each(function () {
    const formId = this.id || "form-" + Math.random().toString(36).substr(2, 9);
    if (!this.id) this.id = formId;

    const validator = FormValidator("#" + formId, {
      errorClass: "is-invalid",
      successClass: "is-valid",
      errorWrapperClass: "error-feedback", // Note: using error-feedback instead of invalid-feedback for login forms
      errorTemplate: "span",
    });
    formValidators.push(validator);
  });

  if ($("#formSignIn").length > 0) {
    // pass username to forgot-password if link is clicked
    $("a.forgot-password").on("click", (e) => {
      e.preventDefault();
      window.location =
        $(e.target).attr("href") + "?user=" + $("#inputUsername").val();
    });

    $(".form-signin").submit((e) => {
      // Prevent Default Submit Event
      e.preventDefault();

      // Get data from the form and put them into variables
      const username = $(e.target).find("#inputUsername").val().toLowerCase();
      const password = $(e.target).find("#inputPassword").val();

      // Call Parse Login function with those variables (Promise-based API)
      Parse.User.logIn(username, password)
        .then((user) => {
          if (user.get("emailVerified") === true) {
            window.location = "/" + redirect;
          } else {
            $("#unverifiedEmailAddress").text(username);

            $("#resendEmail").off("click").on("click", () => {
              const captchaToken = getTurnstileToken("resend");
              if (!captchaToken) {
                $("#remoteErrorMessage").text("Please complete the CAPTCHA challenge.");
                hideModal("emailNotVerifiedModal");
                showModal("errorModal");
                return;
              }

              Parse.Cloud.run("ResendVerifyEmail", {
                email: username,
                captchaToken: captchaToken,
              })
                .then(
                  () => {
                    hideModal("emailNotVerifiedModal");

                    $("#resentEmailAddress").html(username);
                    showModal("emailVerificationReSent");
                  },
                  (error) => {
                    resetTurnstile("resend");
                    hideModal("emailNotVerifiedModal");
                    $("#remoteErrorMessage").text(error.message);
                    showModal("errorModal");
                  },
                )
                .catch((error) => {
                  resetTurnstile("resend");
                  hideModal("emailNotVerifiedModal");
                  $("#remoteErrorMessage").text(error.message);
                  showModal("errorModal");
                });
            });

            showModal("emailNotVerifiedModal");
          }
        })
        .catch((error) => {
          $("#remoteErrorMessage").text(error.message);
          showModal("errorModal");
        });
    });
  }

  if ($("#formRegister").length > 0) {
    $(".form-register").submit((e) => {
      // Prevent Default Submit Event
      e.preventDefault();

      const $form = $(e.target);
      const $submitButton = $form.find('button[type="submit"]');
      if ($form.data("submitting")) {
        return;
      }

      // Get data from the form and put them into variables
      const username = $form.find("#inputUsername").val().toLowerCase();
      const password = $form.find("#inputPassword").val();
      const passwordConfirm = $form.find("#inputRepeatPassword").val();

      if (password !== passwordConfirm) {
        $("#remoteErrorMessage").text("Passwords do not match");
        showModal("errorModal");
        return;
      }

      const captchaToken = getTurnstileToken("register");
      if (!captchaToken) {
        $("#remoteErrorMessage").text("Please complete the CAPTCHA challenge.");
        showModal("errorModal");
        return;
      }

      $form.data("submitting", true);
      $submitButton.prop("disabled", true).text("Creating Account...");

      const firstname = $form.find("#inputFirstname").val();
      const lastname = $form.find("#inputLastname").val();

      Parse.Cloud.run("RegisterLiveSkyUser", {
        email: username,
        password: password,
        firstname: firstname || undefined,
        lastname: lastname || undefined,
        captchaToken: captchaToken,
      })
        .then(() => {
          $("#successEmailAddress").text(username);
          showModal("successModal");
          $("#successModal").on("hidden.bs.modal", () => {
            window.location = "/login.html?user=" + username;
          });
        })
        .catch((error) => {
          $form.data("submitting", false);
          $submitButton.prop("disabled", false).text("Create Account");
          resetTurnstile("register");
          $("#remoteErrorMessage").text(error.message);
          showModal("errorModal");
        });
    });
  }

  if ($("#formResetPassword").length > 0) {
    $("#formResetPassword").submit((e) => {
      // Prevent Default Submit Event
      e.preventDefault();

      // Get data from the form and put them into variables
      const username = $(e.target).find("#inputUsername").val().toLowerCase();

      const captchaToken = getTurnstileToken("reset");
      if (!captchaToken) {
        $("#remoteErrorMessage").text("Please complete the CAPTCHA challenge.");
        showModal("errorModal");
        return;
      }

      Parse.Cloud.run("RequestPasswordResetSafe", {
        email: username,
        captchaToken: captchaToken,
      })
        .then(() => {
          resetTurnstile("reset");
          showModal("successModal");
        })
        .catch((error) => {
          resetTurnstile("reset");
          $("#remoteErrorMessage").text(error.message);
          showModal("errorModal");
        });
    });
  }

  if ($("#formNewPassword").length > 0) {
    const urlParams = {};
    (() => {
      let pair; // Really a match. Index 0 is the full match; 1 & 2 are the key & val.
      const tokenize = /([^&=]+)=?([^&]*)/g;
      // decodeURIComponents escapes everything but will leave +s that should be ' '
      const reSpace = (s) => decodeURIComponent(s.replace(/\+/g, " "));
      // Substring to cut off the leading '?'
      const querystring = window.location.search.substring(1);

      while ((pair = tokenize.exec(querystring))) {
        urlParams[reSpace(pair[1])] = reSpace(pair[2]);
      }
    })();

    const id = urlParams.id;
    const base = Parse.serverURL;
    document
      .getElementById("formNewPassword")
      .setAttribute(
        "action",
        base + "/apps/" + parseApplicationID + "/request_password_reset",
      );
    document.getElementById("username").value = urlParams.username;
    document.getElementById("usernameLabel").value = urlParams.username;

    document.getElementById("token").value = urlParams.token;
    if (urlParams.error) {
      document
        .getElementById("error")
        .appendChild(document.createTextNode(urlParams.error));
    }
    if (urlParams.app) {
      document
        .getElementById("app")
        .appendChild(document.createTextNode(" for " + urlParams.app));
    }
  }
}

// Initialize when DOM is ready using vanilla JavaScript
document.addEventListener("DOMContentLoaded", () => {
  initializeLogin().catch((error) => {
    console.error("Failed to initialize login:", error);
  });
});
